import { mapSeriesWithDatetime } from './shared';

export default {
  buildFields(seriesData, { dateParam }) {
    if (dateParam.aggregatedUnit === 'MINUTE') {
      return [
        { key: 'datetime', label: 'Date Time', class: 'text-center' },
        { key: 'volumeFlowrate', label: 'Volume Flow Rate', class: 'text-center' },
        { key: 'volumeTotal', label: 'Volume Total', class: 'text-center' },
        { key: 'density', label: 'Density', class: 'text-center' },
        { key: 'massFlowrate', label: 'Mass Flow Rate', class: 'text-center' },
        { key: 'massTotal', label: 'Mass Total', class: 'text-center' },
        { key: 'temperature', label: 'Temperature', class: 'text-center' },
      ];
    }
    return [
      { key: 'datetime', label: 'Date Time', class: 'text-center' },
      { key: 'additional.AVG_dlfmVolFlowrate_5', label: 'Volume Flow Rate', class: 'text-center' },
      { key: 'volumeTotal', label: 'Volume Total', class: 'text-center' },
      { key: 'additional.AVG_dlfmDensity_6', label: 'Density', class: 'text-center' },
      { key: 'additional.AVG_dlfmMassFlowrate_4', label: 'Mass Flow Rate', class: 'text-center' },
      { key: 'massTotal', label: 'Mass Total', class: 'text-center' },
      { key: 'additional.AVG_dlfmTemp_7', label: 'Temperature', class: 'text-center' },
    ];
  },
  buildLogs(seriesData) {
    return mapSeriesWithDatetime(seriesData);
  },
  buildSummary(seriesData, { dateParam }) {
    const firstData = seriesData[0];
    const lastData = seriesData[seriesData.length - 1];
    let totalFlow;
    if (dateParam.aggregatedUnit === 'MINUTE') {
      totalFlow = lastData.volumeInventory - firstData.volumeInventory;
    } else {
      totalFlow = lastData.additional.MAX_dlfmVolTotal_1 - firstData.additional.MIN_dlfmVolTotal_0;
    }

    let flowingTime = 0;
    seriesData.forEach((serie, index) => {
      if (serie.volumeFlowrate !== 0 && index !== 0) {
        flowingTime += serie.timestamp - seriesData[index - 1].timestamp;
      }
    });

    const averageFlow = (totalFlow && flowingTime) ? totalFlow / (flowingTime / 3600) : 0;
    return { totalFlow, flowingTime, averageFlow };
  },
};
